import React, { Fragment } from 'react';
import { styled } from 'styled-components';
import { ShowSectionMobile } from './ShowSectionMobile';
import { VideoDescription } from './VideoDescription';
import { VideoInfoPlaceholder } from './VideoInfoPlaceholder';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { Breadcrumbs } from '../../../components/Breadcrumbs/Breadcrumbs';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { useValidTopic } from '../../../hooks/use-valid-topic';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const VideoInfo = ({
  videoDetail
}) => {
  const {
    showsSupported
  } = useVideoConfig();
  const topic = useValidTopic(videoDetail?.topics);
  return /*#__PURE__*/_jsx(Fragment, {
    children: videoDetail ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(PlayContainer, {
        children: /*#__PURE__*/_jsxs(VideoInformationSection, {
          children: [/*#__PURE__*/_jsx(Breadcrumbs, {
            topic: topic,
            show: videoDetail.show
          }), /*#__PURE__*/_jsx(VideoDescription, {
            videoDetail: videoDetail
          })]
        })
      }), showsSupported && videoDetail.show && /*#__PURE__*/_jsx(ShowSectionMobile, {
        show: videoDetail.show
      })]
    }) : /*#__PURE__*/_jsx(VideoInfoPlaceholder, {
      showsSupported: showsSupported
    })
  });
};
const VideoInformationSection = styled.section.withConfig({
  displayName: "VideoInfo__VideoInformationSection",
  componentId: "sc-hnc88s-0"
})(["color:", ";background-color:transparent;padding:16px 0;display:flex;flex-direction:column;gap:16px;", "{padding:24px 0px;}"], Colors.GREY_d2d2d2, Viewports.for('mediumUp'));